import CafeteriaOrdersTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import * as S from './styles';

export default function CafeteriaOrdersListPage() {
  const { orders }: any = useTypedSelector((state) => state.Cafeteria);

  return (
    <S.Container>
      <S.Head>
        <S.Title>Orders List</S.Title>
      </S.Head>
      <Gap size="20px" />
      <CafeteriaOrdersTable menuList={orders?.data} loading={orders?.loading} />
    </S.Container>
  );
}
